import {RouterProvider, createRouter} from '@tanstack/react-router';
import {useEffect} from 'react';
import {AuthProvider, useAuth} from './auth/AuthContext';
import {routeTree} from './routeTree.gen';

const router = createRouter({
  routeTree,
  context: {auth: {isAuthenticated: false, isLoading: true, user: null}},
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function InnerApp() {
  const auth = useAuth();

  // When auth state changes, RouterProvider gets new context, but TanStack Router
  // does not re-run route guards for the current match until navigation or
  // invalidation. Invalidate on auth change so sign-out re-evaluates beforeLoad.
  useEffect(() => {
    void router.invalidate();
  }, [auth]);

  if (auth.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-slate-400">Loading...</p>
      </div>
    );
  }

  return <RouterProvider router={router} context={{auth}} />;
}

function App() {
  return (
    <AuthProvider>
      <InnerApp />
    </AuthProvider>
  );
}

export default App;
